// extracted by mini-css-extract-plugin
module.exports = {"termsContainer":"TermsSection_termsContainer___hBCP","termsLink":"TermsSection_termsLink__E6xSg"};